import { MessageCircle } from "lucide-react";

// Numéro WhatsApp de Solmis Habitat
export const WHATSAPP_NUMBER = "262693521019"; // format international sans + ni espaces
export const PHONE_DISPLAY = "+262 693 52 10 19";
export const PHONE_TEL = "+262693521019";
const WHATSAPP_MESSAGE = encodeURIComponent(
  "Bonjour Solmis Habitat, je souhaite obtenir un devis pour un projet à La Réunion."
);

export const whatsappUrl = () =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;

export default function WhatsAppFloat() {
  return (
    <a
      href={whatsappUrl()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="Contacter Solmis Habitat sur WhatsApp"
      className="hidden md:inline-flex fixed bottom-6 left-6 z-50 group items-center gap-3 bg-[#25D366] text-white pl-4 pr-5 py-3 rounded-full shadow-[0_18px_40px_-12px_rgba(37,211,102,0.55)] hover:bg-[#1ebd5a] transition-all duration-300 hover:-translate-y-0.5"
    >
      <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/15 ring-1 ring-white/30">
        <MessageCircle size={18} strokeWidth={2} />
        <span className="absolute -top-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-white animate-pulse" />
      </span>
      <span className="flex flex-col leading-none">
        <span className="text-[10px] uppercase tracking-[0.18em] text-white/80">
          Discuter sur
        </span>
        <span className="text-sm font-semibold mt-0.5">WhatsApp</span>
      </span>
    </a>
  );
}
